// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';
import { createQuestionMap, setDisplayQuestionMap } from '../state/actions/QuestionMapActions';

import { Error } from '../shared/Error/Error';
import { LoadingIndicator } from '../shared/LoadingIndicator/LoadingIndicator';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// COMPONENT
class AnalysisQuestionMap extends Component {
    constructor(props) {
        super(props);

        this.state = { containerHeight: '500px' };
    }

    componentDidMount() {
        // container resizing to window height
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
        window.addEventListener('mouseup', this.nodeClick, false);

        this.intervalRef = window.setInterval(this.loadMap, 500);
    }

    // container resizing to window height
    componentWillUnmount() {
        window.clearInterval(this.intervalRef);
        window.removeEventListener('resize', this.updateDimensions);
    }

    loadMap = () => {
        const { displayQuestionMap, createQuestionMap, analysis } = this.props;

        if (displayQuestionMap && analysis && analysis.questions) {
            window.clearInterval(this.intervalRef);

            createQuestionMap(analysis.questions, 'mermaid');
        }
    };

    updateDimensions = () => {
        const containerHeight = window.innerHeight - 225 + 'px';

        // sets the height of container to window
        this.setState({
            containerHeight: containerHeight,
        });
    };

    nodeClick = e => {
        const parent = e.target.closest('.clickable');
        if (
            parent &&
            parent.classList &&
            parent.classList.contains('node') &&
            parent.classList.contains('clickable')
        ) {
            this.props.onNodeClick(parent.id);
        }
    };

    toggleQuestionMapDisplay = () => {
        const { displayQuestionMap, setDisplayQuestionMap } = this.props;

        setDisplayQuestionMap(!displayQuestionMap);
    };

    render() {
        const { fetched, failed, fetching, displayQuestionMap, questionMap } = this.props;

        let cardBody = null;

        if (displayQuestionMap) {
            if (!fetched) {
                cardBody = <LoadingIndicator busy={fetching} />;
            } else if (failed) {
                cardBody = <Error message="Failed to create question map" />;
            } else {
                cardBody = (
                    <div
                        className="mermaid w-100"
                        id="mermaid"
                        style={{ height: this.state.containerHeight }}
                        dangerouslySetInnerHTML={{ __html: questionMap }}
                    />
                );
            }
        }

        return (
            <div className="card">
                <div className="card-header">
                    Question Flow
                    <div className="float-right">
                        <button
                            className={
                                'ml-2 btn btn-sm ' +
                                (displayQuestionMap ? 'btn-primary' : 'btn-primary-outline')
                            }
                            onClick={this.toggleQuestionMapDisplay}
                        >
                            Show Question Flow
                        </button>
                    </div>
                </div>
                <div
                    className="card-body"
                    style={{ overflow: 'auto', minHeight: displayQuestionMap ? '400px' : '' }}
                >
                    {cardBody}
                </div>
            </div>
        );
    }
}

AnalysisQuestionMap.propTypes = {
    setDisplayQuestionMap: PropTypes.func.isRequired,
    createQuestionMap: PropTypes.func.isRequired,
    onNodeClick: PropTypes.func.isRequired,
    displayQuestionMap: PropTypes.bool.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    questionMap: PropTypes.string,
    analysis: PropTypes.object,
    failed: PropTypes.bool,
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetching, fetched, failed, displayQuestionMap, questionMap } = state.questionMap;
    const { analysis } = state.analysis;

    return { fetching, fetched, failed, displayQuestionMap, questionMap, analysis };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({ setDisplayQuestionMap, createQuestionMap }, dispatch);

const hoc = connect(mapStateToProps, mapDispatchToProps)(AnalysisQuestionMap);

// EXPORT COMPONENT
export { hoc as AnalysisQuestionMap };
